package com.fireavert.devices.data_models.requests

import kotlinx.serialization.Serializable

@Serializable
data class DevicePoweredOnRequest(
    val deviceIds: List<Int>
)